export default __webpack_public_path__ + "static/FS2S-InHub-43-cd6f669677a6f4892e2e881ced41235e.jpg";